// extracted by mini-css-extract-plugin
export var acitonButtons = "_ep-0";
export var additionalIcon = "_ep-f";
export var block = "_ep-1";
export var blockContent = "_ep-7";
export var blockDescription = "_ep-8";
export var blockIcon = "_ep-9";
export var blockTitle = "_ep-6";
export var border = "_ep-a";
export var center = "_ep-l";
export var edge = "_ep-b";
export var edgeLabel = "_ep-c";
export var edgePath = "_ep-d";
export var error = "_ep-e";
export var flowchart = "_ep-g";
export var flowchartContent = "_ep-h";
export var highlighted = "_ep-3";
export var hover = "_ep-4";
export var icon = "_ep-i";
export var left = "_ep-m";
export var navButton = "_ep-j";
export var navButtons = "_ep-k";
export var right = "_ep-n";
export var selected = "_ep-2";
export var small = "_ep-5";